/**
 * @module app.track.poiicon
 */
import {TRACK_COLOR_VALUES} from "../constants";

export const SIZE = [20, 33];

/**
 * @private
 * @param {string|number|undefined} text
 * @param {string} textColor
 */
export function makeText_(text, textColor) {
  if (text) {
    const textStr = String(text);
    return `
    <text x="${10 - 3.6 * textStr.length}" y="15" font-family='"Courier New", monospace' font-size="12" font-weight="bold" fill="${textColor}">
      ${textStr}
    </text>`;
  }
  return '';
}

/**
 * @param {TRACK_COLOR} trackColor
 * @param {string|number=} text
 */
export function makeIcon(trackColor, text) {
  const {color, tickColor} = TRACK_COLOR_VALUES[trackColor];
  const svg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="${SIZE[0]}" height="${SIZE[1]}">
    <path d="M10 0C5 0 .5 3 .5 9c0 4 9.5 24 9.5 24s9.5-20 9.5-24c0-6-4.5-9-9.5-9z" fill="${color}"/>
    ${makeText_(text, tickColor)}
  </svg>`;
  return 'data:image/svg+xml;base64,' + btoa(svg);
}
